export default __webpack_public_path__ + "static/media/sprite.824d050b.svg";